import { ClaimFileUploadAdapter } from '../../../adapter';

export default async function ClaimFileUploadUseCase(event) {

    const url = window.location.href;
    const isLocalhost = url.includes('localhost') || url.includes('hcc.dev.bpimsapps.com');
    const isUAT = url.includes('hcc.uat.bpimsapps.com');
    const isProd = url.includes('homeprotectionclaims.bpims.com');
    const [, stage, , flag] = url.split('.');

    // prepare data
    const endpoint = isLocalhost
        ? 'https://partners-api.dev.bpimsapps.com/claim/claim-file/get'
        : isUAT
        ? 'https://partners-api.uat.bpimsapps.com/claim/claim-file/get'
        : isProd
        ? `${flag ? 'https://partners-api' : 'https://fes'}.${flag ? `${stage}.` : ''}bpimsapps.com${
              flag ? '' : '/partners'
          }/claim/claim-file/get`
        : `${flag ? 'https://partners-api' : 'https://fes'}.${flag ? `${stage}.` : ''}bpimsapps.com${
              flag ? '' : '/partners'
          }/claim/claim-file/get`;

    // const payload = {
    //     ...event
    // };

    // handle request
    // const result = await ClaimFileUploadAdapter(endpoint, JSON.stringify(payload));
    const result = await ClaimFileUploadAdapter(event.requestUrl, event.contentType, event.file);

    return result;
}
